let language = {
    MODIFY_EMAIL_SECURITY_TEXT: "邮箱安全",
    MODIFY_EMAIL_TITLE_TEXT: "修改邮箱账户",
    MODIFY_EMAIL_LABLE_TEXT: "输入您的电子邮箱，我们将向您发送电子邮箱确认链接。这可能需要几分钟的时间！",
    MODIFY_EMAIL_REQUIRED_TEXT: "不能为空",
    MODIFY_EMAIL_PATTERN_TEXT: "电子邮箱格式不正确",
    MODIFY_EMAIL_PLACEHOLDER_TEXT: "请输入有效的电子邮箱地址",

    MODIFY_EMAIL_CANCEL_TEXT: "取消",
    MODIFY_EMAIL_CONFIRM_TEXT: "确认",
};

export { language }